var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Dashboard")]),
    _c(
      "div",
      { staticClass: "d-flex mb-3" },
      [
        _c(
          "div",
          { staticClass: "mr-2" },
          [
            _c("autocomplete-input", {
              attrs: {
                path:
                  "/distributors?withProject=1&project=name&project=_id&fields=name&fields=name&ascending=1&orderBy=name",
                name: "Select distributor(s)",
                label: "name",
                multiple: "",
                loadOnFocus: "",
                placeholder: "Select distributor(s)",
                isObject: "",
                "track-by": "_id",
              },
              model: {
                value: _vm.selectedFilter.distributorId,
                callback: function ($$v) {
                  _vm.$set(_vm.selectedFilter, "distributorId", $$v)
                },
                expression: "selectedFilter.distributorId",
              },
            }),
          ],
          1
        ),
        _c("DateRange", {
          attrs: { dateRange: _vm.dashboardDateRange, showRefresh: true },
          on: { onChange: _vm.dateRangeSelected },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8" }, [
        _c("div", { staticClass: "card mb-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("div", { staticClass: "card-title" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col" }, [
                    _c("h5", [_vm._v("Sales")]),
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm._f("currency")(
                            _vm.myReports.sales.total || 0,
                            _vm.distributorCurrencySign
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("h5", { staticClass: "font-weight-normal" }, [
                      _vm._v("Net Profit"),
                    ]),
                    _c("h3", { staticClass: "font-weight-normal" }, [
                      _vm._v(
                        "\n                  " +
                          _vm._s(
                            _vm._f("currency")(
                              _vm.myReports.salesTotals.profit || 0,
                              _vm.distributorCurrencySign
                            )
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("h5", { staticClass: "font-weight-normal" }, [
                      _vm._v("Gross Margin"),
                    ]),
                    _c("h3", { staticClass: "font-weight-normal" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("percent")(
                            _vm.myReports.salesTotals.grossMargin || 0
                          )
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "col" }, [
                    _c("h5", { staticClass: "font-weight-normal" }, [
                      _vm._v("Net Margin"),
                    ]),
                    _c("h3", { staticClass: "font-weight-normal" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("percent")(
                            _vm.myReports.salesTotals.netMargin || 0
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm.myReports.sales.data
                ? _c(
                    "div",
                    [
                      _c("line-chart", {
                        attrs: {
                          height: 440,
                          isCurrency: true,
                          data: _vm.myReports.sales.data.map((i) => ({
                            x: i.label,
                            y: i.total,
                          })),
                          period: _vm.dashboardDateRange.short,
                        },
                      }),
                    ],
                    1
                  )
                : _c("vue-content-loading", [
                    _c("rect", {
                      staticClass: "w-100",
                      attrs: { x: "0", y: "0", rx: "4", ry: "4", height: 150 },
                    }),
                  ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card mb-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm._m(0),
              _vm.myReports.orders.data
                ? _c(
                    "div",
                    [
                      _c("h3", [_vm._v(_vm._s(_vm.myReports.orders.total))]),
                      _c("line-chart", {
                        attrs: {
                          height: 150,
                          data: _vm.myReports.orders.data.map((i) => ({
                            x: i.label,
                            y: i.count,
                          })),
                          period: _vm.dashboardDateRange.short,
                        },
                      }),
                    ],
                    1
                  )
                : _c("vue-content-loading", [
                    _c("rect", {
                      staticClass: "w-100",
                      attrs: { x: "0", y: "0", rx: "4", ry: "4", height: 100 },
                    }),
                  ]),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "card mb-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _vm._m(1),
              _vm.myReports.profit.data
                ? _c(
                    "div",
                    [
                      _c("h3", [
                        _vm._v(
                          _vm._s(
                            _vm._f("currency")(
                              _vm.myReports.profit.total,
                              _vm.distributorCurrencySign
                            )
                          )
                        ),
                      ]),
                      _c("line-chart", {
                        attrs: {
                          height: 150,
                          isCurrency: true,
                          data: _vm.myReports.profit.data.map((i) => ({
                            x: i.label,
                            y: i.profit,
                          })),
                          period: _vm.dashboardDateRange.short,
                        },
                      }),
                    ],
                    1
                  )
                : _c("vue-content-loading", [
                    _c("rect", {
                      staticClass: "w-100",
                      attrs: { x: "0", y: "0", rx: "4", ry: "4", height: 100 },
                    }),
                  ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "card mb-4" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "card-title" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h5", [_vm._v("Sales")]),
                  _c("h3", [
                    _vm._v(
                      _vm._s(
                        _vm._f("currency")(
                          _vm.getOrdersAndSalesTotal("totalPrice"),
                          _vm.distributorCurrencySign
                        )
                      )
                    ),
                  ]),
                ]),
              ]),
            ]),
            _c(
              "div",
              [
                _vm.loadedReports ||
                _vm.myReports.ordersAndSalesByDistributor.length
                  ? _c(
                      "div",
                      [
                        _c("bar-chart", {
                          attrs: {
                            height: 600,
                            isCurrency: true,
                            data: _vm.sortedBarData(
                              "ordersAndSalesByDistributor",
                              "totalPrice"
                            ),
                          },
                        }),
                      ],
                      1
                    )
                  : _c("vue-content-loading", [
                      _c("rect", {
                        staticClass: "w-100",
                        attrs: {
                          x: "0",
                          y: "0",
                          rx: "4",
                          ry: "4",
                          height: 300,
                        },
                      }),
                    ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "card mb-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("div", { staticClass: "card-title" }, [
                _c("h5", [_vm._v("Orders")]),
                _c("h3", [
                  _vm._v(_vm._s(_vm.getOrdersAndSalesTotal("totalCount"))),
                ]),
              ]),
              _vm.loadedReports ||
              _vm.myReports.ordersAndSalesByDistributor.length
                ? _c(
                    "div",
                    [
                      _c("bar-chart", {
                        attrs: {
                          height: 600,
                          data: _vm.sortedBarData(
                            "ordersAndSalesByDistributor",
                            "totalCount"
                          ),
                        },
                      }),
                    ],
                    1
                  )
                : _c("vue-content-loading", [
                    _c("rect", {
                      staticClass: "w-100",
                      attrs: { x: "0", y: "0", rx: "4", ry: "4", height: 300 },
                    }),
                  ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card mb-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("div", { staticClass: "card-title" }, [
                _c("h5", [_vm._v("Quotes")]),
                _c("h3", { staticClass: "mr-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getStatusByDistributorCount("quotesByDistributor")
                    )
                  ),
                ]),
              ]),
              _vm.loaded || _vm.myReports.quotesByDistributor.length
                ? _c(
                    "div",
                    [
                      _c("bar-chart", {
                        attrs: {
                          height: 300,
                          data: _vm.sortedBarData(
                            "quotesByDistributor",
                            "totalCount"
                          ),
                        },
                      }),
                    ],
                    1
                  )
                : _c("vue-content-loading", [
                    _c("rect", {
                      staticClass: "w-100",
                      attrs: { x: "0", y: "0", rx: "4", ry: "4", height: 100 },
                    }),
                  ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card mb-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("div", { staticClass: "card-title" }, [
                _c("h5", [_vm._v("Proofs")]),
                _c("h3", { staticClass: "mr-2" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getStatusByDistributorCount("proofsByDistributor")
                    )
                  ),
                ]),
              ]),
              _vm.loadedReports || _vm.myReports.proofsByDistributor.length
                ? _c(
                    "div",
                    [
                      _c("bar-chart", {
                        attrs: {
                          height: 300,
                          data: _vm.sortedBarData(
                            "proofsByDistributor",
                            "totalCount"
                          ),
                        },
                      }),
                    ],
                    1
                  )
                : _c("vue-content-loading", [
                    _c("rect", {
                      staticClass: "w-100",
                      attrs: { x: "0", y: "0", rx: "4", ry: "4", height: 100 },
                    }),
                  ]),
            ],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "col-md-4" }, [
        _c("div", { staticClass: "card mb-4" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("div", { staticClass: "card-title" }, [
                _c("h5", [_vm._v("Customers")]),
                _c("h3", [_vm._v(_vm._s(_vm.getCustomersTotal("totalCount")))]),
              ]),
              _vm.loadedReports ||
              _vm.myReports.customersCountByDistributor.length
                ? _c(
                    "div",
                    [
                      _c("bar-chart", {
                        attrs: {
                          height: 300,
                          data: _vm.sortedBarData(
                            "customersCountByDistributor",
                            "totalCount"
                          ),
                        },
                      }),
                    ],
                    1
                  )
                : _c("vue-content-loading", [
                    _c("rect", {
                      staticClass: "w-100",
                      attrs: { x: "0", y: "0", rx: "4", ry: "4", height: 150 },
                    }),
                  ]),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("h5", [_vm._v("Orders")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-title" }, [
      _c("h5", [_vm._v("Net Profit")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }